(() => {
  if (window.dwcRelatedTooltipInitialised) return;
  window.dwcRelatedTooltipInitialised = true;

  const selector = '[data-dwc-related-tooltip]';

  const updateTooltip = (tooltip) => {
    const viewport = tooltip.querySelector('.dwc-related-option__hover-viewport');
    const track = tooltip.querySelector('.dwc-related-option__hover-track');
    const text = tooltip.querySelector('.dwc-related-option__hover-text');
    if (!viewport || !track || !text) return;

    const textWidth = Math.ceil(text.getBoundingClientRect().width);
    const viewportWidth = Math.ceil(viewport.clientWidth);
    const isOverflowing = textWidth > viewportWidth + 1;
    const gap = Math.max(18, Math.round(viewportWidth * 0.12));
    const distance = textWidth + gap;
    const resources = tooltip.closest('.dwc-variant-resources');
    const configuredSpeed = Number(
      getComputedStyle(resources || tooltip).getPropertyValue(
        '--dwc-tooltip-scroll-speed'
      )
    );
    const speed = Number.isFinite(configuredSpeed) && configuredSpeed > 0
      ? configuredSpeed
      : 32;

    tooltip.classList.toggle('is-overflowing', isOverflowing);
    tooltip.style.setProperty('--dwc-tooltip-scroll-gap', `${gap}px`);
    tooltip.style.setProperty('--dwc-tooltip-scroll-distance', distance);
    tooltip.style.setProperty(
      '--dwc-tooltip-scroll-duration',
      `${Math.max(0.8, distance / speed).toFixed(2)}s`
    );
  };

  const updateAll = (root = document) => {
    root.querySelectorAll(selector).forEach(updateTooltip);
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches(selector)) updateTooltip(node);
        updateAll(node);
      });
    });
  });

  const initialise = () => {
    updateAll();
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('resize', () => updateAll(), { passive: true });
    document.addEventListener('shopify:section:load', (event) => updateAll(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
